import { $http } from '@/plugins/axios';
import { AxiosResponse } from 'axios';

export const chatService = {
    listChatGroup: (searchQuery: string): Promise<AxiosResponse> => {
        return $http.get('v1/staff/bot_chat_groups', { params: { query: searchQuery } });
    },
    getChatGroup: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/staff/bot_chat_groups/${id}`);
    },
    getStudentChatGroup: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/staff/bot_chat_groups/by_student/${id}`);
    },
    sendMessage: (message: string): Promise<AxiosResponse> => {
        return $http.post(`v1/staff/bot_chat_messages`, { message });
    },
    generateStudentContext: (id: string): Promise<AxiosResponse> => {
        return $http.put(`v1/staff/students/${id}/student_context?force=true`);
    },
    updateStudentContext: (id: string, studentContext: string): Promise<AxiosResponse> => {
        return $http.put(`v1/staff/students/${id}/staff_student_context`, { context: studentContext });
    },
    getStats: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/staff/students/${id}/student_context/complete_goal_of_skill_stats`);
    }
}